import React, { useContext, useState } from "react";
import "./ColorByNumberFinished.css";
import { SettingsContext } from "./Settings/SettingsContext.tsx";
import { paletteColor, PICTURE_CELLS, PICTURE_COLUMNS } from "./ColorByNumberPicture.ts";
import { useTranslation } from "../Shared/i18n/useTranslation.ts";

/**
 * The finished color-by-number picture, on screen (ADR 0058 amendment):
 * what a sheet looks like once every square is coloured by its answer.
 *
 * Drawn from the same picture data the PDF colours its answer page from, so
 * the two cannot disagree. Plain HTML rather than a PDF, so it shows on any
 * screen and costs nothing from the lazily-loaded renderer. Hidden until
 * asked for - the sheet is a reveal, and a child at the screen should not
 * see the answer first.
 */
export function ColorByNumberFinished() {
    const { settings, setSettings } = useContext(SettingsContext);
    const t = useTranslation();
    const [shown, setShown] = useState(false);

    return (
        <section className="cbnFinished">
            <button type="button" className="cbnFinishedToggle" aria-expanded={shown} onClick={() => setShown((s) => !s)}>
                {shown ? t("settings.cbnHideFinished") : t("settings.cbnShowFinished")}
            </button>
            {shown && (
                <>
                    <div
                        className="cbnFinishedGrid"
                        role="img"
                        aria-label={t("settings.cbnFinishedAria")}
                        style={{ gridTemplateColumns: `repeat(${PICTURE_COLUMNS}, 1fr)` }}
                    >
                        {PICTURE_CELLS.map((color, index) => (
                            <span key={index} style={{ background: paletteColor(color).fill }} />
                        ))}
                    </div>
                    <p className="cbnFinishedCaption">{t("settings.cbnFinishedCaption")}</p>
                    {settings.AnswerPages ? (
                        <p className="cbnFinishedCaption">{t("settings.cbnAnswerPagesOn")}</p>
                    ) : (
                        <button
                            type="button"
                            className="cbnFinishedAnswerPages"
                            onClick={() => setSettings({ ...settings, AnswerPages: true })}
                        >
                            {t("settings.cbnAddAnswerPages")}
                        </button>
                    )}
                </>
            )}
        </section>
    );
}

export default ColorByNumberFinished;
